import './InboxBugStatusSelection.scss';
import { BugStore } from 'stores/private/BugStore';
import { inject, observer } from 'mobx-react';
import PrimaryButton from 'components/PrimaryButton/PrimaryButton';
import LinkButton from 'components/LinkButton/LinkButton';
import { ampli } from 'ampli';
import ReactTooltip from 'react-tooltip';
import { isMacintosh, useHotkey } from 'services/Helper';

interface InboxBugStatusSelectionProps {
  bugStore?: BugStore;
  isInbox?: boolean;
}

const InboxBugStatusSelection = ({
  bugStore,
  isInbox = false,
}: InboxBugStatusSelectionProps) => {
  const bug = bugStore?.currentBug;
  const isFeatureRequest = bug?.type === 'FEATURE_REQUEST';

  const closeConversation = () => {
    if (!bug) {
      return;
    }

    bugStore!.updateBug(bug.id, {
      status: 'DONE',
    });
    bugStore!.clearCurrentBug();

    ampli.ticketClosed({
      bugId: bug.id,
    });
  };

  useHotkey(80, closeConversation);

  if (!bug) {
    return null;
  }

  if (isFeatureRequest) {
    return null;
  }

  return (
    <div className="ml-10">
      {bug.status !== 'DONE' ? (
        <>
          <ReactTooltip
            id="closeButtonTooltip"
            className="infoTooltip infoTooltipButton"
            delayHide={0}
            type="light"
            effect="solid"
            getContent={(content) => {
              return (
                <div className="send-key-tooltip">
                  <span>{content}</span>
                  <div className="hotkey-help">
                    {isMacintosh() ? <div>⌘</div> : <div>Ctrl</div>}
                    <div>Shift</div>
                    <div>P</div>
                  </div>
                </div>
              );
            }}
          />
          <div data-for="closeButtonTooltip" data-tip={`Close ${isInbox ? 'conversation' : 'ticket'}`}>
            <PrimaryButton
              className="bfw"
              label="Close"
              icon="check"
              onClick={() => {
                closeConversation();
              }}
            />
          </div>
        </>
      ) : (
        <LinkButton
          className="bfw"
          label="Open"
          iconSideRight={false}
          icon="inbox"
          onClick={() => {
            bugStore!.updateBug(bug.id, {
              status: 'OPEN',
            });
            bugStore!.clearCurrentBug();
          }}
        />
      )}
    </div>
  );
};

export default inject('bugStore')(observer(InboxBugStatusSelection));
